import { formatStringToTitleCase } from 'utils/formatters'
import { fromGlobalId } from 'utils/transformations/graphql'

const BRAND_CARRIED_NAME_MAX_LENGTH = 255

export const normalizeBrandCarriedName = (name: string): string => {
  const normalized = formatStringToTitleCase(name.trim().replace(/\s+/g, ' '))
  return normalized.length > BRAND_CARRIED_NAME_MAX_LENGTH
    ? normalized.slice(0, BRAND_CARRIED_NAME_MAX_LENGTH)
    : normalized
}

export const normalizeBrandsCarriedNames = (
  brandsCarried?: string[] | null,
): string[] =>
  (brandsCarried ?? [])
    .map(normalizeBrandCarriedName)
    .filter((brandName) => brandName.length > 0)

export const normalizeBrandCarriedSelection = (brand: {
  id?: string | null
  name?: string | null
}): string => normalizeBrandCarriedName(brand?.name || brand?.id || '')

const isValidRelayId = (id: string): boolean => {
  try {
    return Boolean(fromGlobalId(id).id)
  } catch {
    return false
  }
}

export const isNonJoorCarriedBrandId = (id: string): boolean =>
  Boolean(id) && !isValidRelayId(id)
